export default "__VITE_ASSET__Br$kB3JX__"